import { select } from 'glamor'
import Link from "gatsby-link"
import Img from "gatsby-image"

const columnisePhotos = photos => {
	const columnCount = 3
	const columnHeights = Array(columnCount).fill(0)
	const columns = columnHeights.map(i => [])

	const selectShortestIdx = () => {
		let shortestIdx = 0
		for (let i = 1; i < columnCount; i++) {
			if (columnHeights[i] < columnHeights[shortestIdx]) {
				shortestIdx = i
			}
		}
		return shortestIdx
	}

	photos.forEach(photo => {
		const idx = selectShortestIdx()
		columns[idx].push(photo)
		columnHeights[idx] += photo.resolutions.height
	})
	return columns
}

const Gallery = ({ photos }) => 
	<div css={{ display: `flex` }}>
		{columnisePhotos(photos).map((column, i) =>
			<div key={i} css={[select(`& + &`, { marginLeft: 9 })]}>
				{column.map(p => <Img key={p.key} resolutions={p.resolutions} />)}
			</div>)}
	</div>

export const query = graphql`
  query HandCraftImageQuery {
    allFile(filter:{relativePath:{glob:"imgs/pottery/*"}}) {
    	edges {
    		node {
    			name
		      childImageSharp {
		        resolutions(width: 244, quality: 90) {
		          ...GatsbyImageSharpResolutions_tracedSVG
		        }
		      }
		    }
		  }
		}
  }
`

const dataToPhotos = data =>
	data.allFile.edges
	.map( ({
		node: {
			name,
			childImageSharp: {
				resolutions,
			},
		},
	}) => ({
		key: name,
		resolutions,
	}) )

const Handcraft = ({ data }) =>
	<div>
		<div css={{ margin: `0 0.5rem` }}>
			<Link css={{ float: `right` }} to="/">Back</Link>
			<h3>Pottery</h3>
		</div>
		<Gallery photos={dataToPhotos(data)} />
	</div>
	
export default Handcraft



// WEBPACK FOOTER //
// ./src/pages/handcraft.js